import { MessageCoreBase } from "./message.core.base"


export class MessageCore extends MessageCoreBase {

}